import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import utils from '../../../utils';
import type { Revision } from '../../../types';

const maxRevisionCount = 12;

export type BranchAndTagMap = {
  branch: Record<string, Revision[]>;
  tag: Record<string, Revision[]>;
};

type GetProjectRevisionsParams = {
  projectLocator: string;
  revisionLocatorFilter?: string;
  refsType?: string;
  refName?: string;
  count?: number;
  source?: string;
  shouldFetchOnlyResolvedRevisions?: boolean;
};

const getProjectRevisions = ({
  projectLocator,
  revisionLocatorFilter,
  refsType,
  refName,
  count = maxRevisionCount,
  source,
  shouldFetchOnlyResolvedRevisions,
}: GetProjectRevisionsParams) => {
  return get<BranchAndTagMap>(`/api/projects/${utils.nuc(projectLocator)}/revisions`, false, {
    locator: revisionLocatorFilter,
    count,
    offset: 0,
    refs: [refName],
    refs_type: refsType,
    source,
    resolved: shouldFetchOnlyResolvedRevisions,
  });
};

const getQueryKey = (params: GetProjectRevisionsParams): QueryKey => ['projects', params, 'revisions'];

/**
 * useProjectRevisions is a hook that fetches the revisions for a project.
 */
const useProjectRevisions = (params: GetProjectRevisionsParams) => {
  return useQuery({
    queryKey: getQueryKey(params),
    queryFn: () => getProjectRevisions(params),
  });
};

export default useProjectRevisions;
